(function ($) {
	objectFitPolyfill();

	var body = $('body');

	AOS.init({
		duration: 600,
		easing: 'ease-in-out',
	});

	if ($(document)
		.scrollTop() >= 100) {
		body.addClass('scrolled')
	}

	$(document)
		.scroll(function () {
			if ($(this)
				.scrollTop() >= 100) {
				body.addClass('scrolled')
			} else {
				body.removeClass('scrolled')
			}
		});

	var body = $('body');
	$('.toggle-menu, .menu-close')
		.on('click', function (e) {
			body.toggleClass('open-menu');
			e.preventDefault();
		});

	var myEl = document.getElementById("offcanvas")
	var hammertime = new Hammer(myEl);
	hammertime.on('swipeleft', function (ev) {
		body.toggleClass('open-menu');
	});

	$('#myBtn').click(function (e) {
		$("#formModal").toggle();
		e.preventDefault();
	});

	$('#closeModal').click(function (e) {
		$("#formModal").toggle();
		e.preventDefault();
	});

	//modal
	$('[data-toggle="modal"]').click(function (e) {
		e.preventDefault();
		const target = $(this).attr('data-target');
		$('body').toggleClass('modal-open');
		$(target).toggle();
	});

	$('.modal .close').click(function(e) {
		$('body').toggleClass('modal-open');
		$(this).parents('.modal').toggle();
	});

	$('.modal').click(function(e) {
		if(e.target !== e.currentTarget) return;
		$('body').toggleClass('modal-open');
		$(this).toggle();
	});


	//counterup
	$('.counter').counterUp({
		time: 3200
	});

	$(".rotate").textrotator({
		animation: "fade", // You can pick the way it animates when rotating through words. Options are dissolve (default), fade, flip, flipUp, flipCube, flipCubeUp and spin.
		separator: ",", // If you don't want commas to be the separator, you can define a new separator (|, &, * etc.) by yourself using this field.
		speed: 2400 // How many milliseconds until the next word show.
	  });

})(jQuery);
